import { FormModel } from '../../../../../components/Form';
import { Validators } from '../../../../../utils/validators';

const row2Responsive = { xs: 12, sm: 6 };

const compactUploadSx = {
  minHeight: '96px',
  py: 0.5,
  '& .MuiTypography-root': {
    fontSize: '0.875rem',
  },
};

export const AddPaymentDrawerFormModel = (
  strings: any,
  paymentMethodList: { value: any; label: any }[],
  showPan: boolean,
  isRefund: boolean = false,
  formData: any = {},
  isYcs: boolean = false,
): FormModel[] => {
  const row1NoDoc = {
    paymentMethod: { xs: 12, sm: 6 },
    amount: { xs: 12, sm: 6 },
    paymentReference: { xs: 12, sm: 6 },
    tds: { xs: 12, sm: 6 },
  };
  const row1WithDoc = {
    paymentMethod: { xs: 12, sm: 6 },
    amount: { xs: 12, sm: 6 },
    paymentReference: { xs: 12, sm: 6 },
    docNo: { xs: 12, sm: 6 },
    tds: { xs: 12, sm: 6 },
  };
  const row1 = showPan ? row1WithDoc : row1NoDoc;

  const form: FormModel[] = [
    {
      label: isRefund ? 'Refund Method' : strings.bookingDetailsAddPayment_paymentMethod,
      value: '',
      size: 'medium',
      type: 'drop-down',
      placeholder: '',
      field: 'paymentMethod',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: row1.paymentMethod,
      required: true,
      options: paymentMethodList,
    },
    {
      label: isRefund ? 'Refund Amount' : strings.paymentDetails_title_paid,
      value: '',
      size: 'medium',
      autoFocus: false,
      type: 'text',
      typeValue: 'number',
      variant: 'outlined',
      placeholder: '',
      field: 'amount',
      validators: [{ check: Validators.validateMandatoryField }, { check: Validators.validateFloat }],
      responsive: row1.amount,
      required: true,
    },
    {
      label: isRefund ? 'Refund Reference' : strings.paymentDetails_text_reference,
      value: '',
      size: 'medium',
      autoFocus: false,
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'paymentReference',
      validators: [{ check: Validators.validateMandatoryField }, { check: Validators.validateString, max: 50 }],
      responsive: row1.paymentReference,
      required: true,
    },
  ];

  if (showPan) {
    form.push({
      label: strings.paymentDetails_title_pan_card,
      value: '',
      size: 'medium',
      autoFocus: false,
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'docNo',
      inputProps: { style: { textTransform: 'uppercase' } },
      validators: [{ check: Validators.validateMandatoryField }, { check: Validators.validateString }],
      responsive: row1WithDoc.docNo,
      required: true,
    });
  }

  form.push(
    {
      label: 'TDS Status',
      value: false,
      type: 'checkbox',
      field: 'isTdsDeducted',
      responsive: row1.tds,
      placeholder: '',
      validators: [],
      required: false,
    },
    {
      label: 'Room Number',
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'roomNumber',
      validators: isYcs
        ? [{ check: Validators.validateMandatoryField }, { check: Validators.validateString, max: 50 }]
        : [{ check: Validators.validateString, max: 50 }],
      responsive: row2Responsive,
      required: isYcs,
    },
    {
      label: 'Room ID',
      value: formData.roomReservationId || '',
      size: 'medium',
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'roomReservationId',
      validators: [{ check: Validators.validateString, max: 50 }],
      responsive: row2Responsive,
      required: false,
      disabled: true,
    },
    {
      label: 'Guest Name',
      value: formData.roomReservationName || '',
      size: 'medium',
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'roomReservationName',
      validators: [{ check: Validators.validateString, max: 100 }],
      responsive: row2Responsive,
      required: false,
      disabled: true,
    },
    {
      label: isRefund ? 'Upload Refund Document' : strings.upload_document,
      value: '',
      type: 'upload',
      placeholder: '',
      field: 'attachment',
      validators: [],
      responsive: { xs: 12 },
      required: false,
      multiline: false,
      sx: compactUploadSx,
    },
  );

  return form;
};

export const AddPaymentFormModel = (
  strings: any,
  paymentMethodList: { value: any; label: any }[],
  showPan: boolean,
  width = 12,
  isRefund: boolean = false,
  formData: any = {},
  isYcs: boolean = false,
): FormModel[] => {
  const form: FormModel[] = [
    // Payment Details Section
    {
      label: 'Payment Details',
      value: null,
      type: 'section',
      placeholder: '',
      field: null,
      validators: [],
      responsive: { xs: 12 },
      required: false,
    },
    {
      label: isRefund ? 'Refund Method' : strings.bookingDetailsAddPayment_paymentMethod,
      value: '',
      size: 'medium',
      type: 'drop-down',
      placeholder: '',
      field: 'paymentMethod',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: width },
      required: true,
      options: paymentMethodList,
    },
    {
      label: isRefund ? 'Refund Amount' : strings.paymentDetails_title_paid,
      value: '',
      size: 'medium',
      autoFocus: false,
      type: 'text',
      typeValue: 'number',
      variant: 'outlined',
      placeholder: '',
      field: 'amount',
      validators: [{ check: Validators.validateMandatoryField }, { check: Validators.validateFloat }],
      responsive: { xs: width },
      required: true,
    },
    {
      label: isRefund ? 'Refund Reference' : strings.paymentDetails_text_reference,
      value: '',
      size: 'medium',
      autoFocus: false,
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'paymentReference',
      validators: [{ check: Validators.validateMandatoryField }, { check: Validators.validateString, max: 50 }],
      responsive: { xs: width },
      required: true,
    },
    
    // Booking Details Section
    {
      label: 'Booking Details',
      value: null,
      type: 'section',
      placeholder: '',
      field: null,
      validators: [],
      responsive: { xs: 12 },
      required: false,
    },
    {
      label: 'Room Number',
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'roomNumber',
      validators: isYcs
        ? [{ check: Validators.validateMandatoryField }, { check: Validators.validateString, max: 50 }]
        : [{ check: Validators.validateString, max: 50 }],
      responsive: { xs: width },
      required: isYcs,
    },
    {
      label: 'Reservation ID',
      value: formData.roomReservationId || '',
      size: 'medium',
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'roomReservationId',
      validators: [{ check: Validators.validateString, max: 50 }],
      responsive: { xs: width },
      required: false,
      disabled: true,
    },
    {
      label: 'Guest Name',
      value: formData.roomReservationName || '',
      size: 'medium',
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'roomReservationName',
      validators: [{ check: Validators.validateString, max: 100 }],
      responsive: { xs: width },
      required: false,
      disabled: true,
    },
  ];

  // Other Section
  form.push(
    {
      label: 'Other',
      value: null,
      type: 'section',
      placeholder: '',
      field: null,
      validators: [],
      responsive: { xs: 12 },
      required: false,
    }
  );

  showPan &&
    form.push({
      label: strings.paymentDetails_title_pan_card,
      value: '',
      size: 'medium',
      autoFocus: false,
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'docNo',
      inputProps: { style: { textTransform: 'uppercase' } },
      validators: showPan ? [{ check: Validators.validateMandatoryField }, { check: Validators.validateString }] : [],
      responsive: { xs: width },
      required: true,
    });

  form.push(
    {
      label: 'TDS Status',
      value: false,
      type: 'checkbox',
      field: 'isTdsDeducted',
      responsive: { xs: 12 },
      placeholder: '',
      validators: [],
      required: false,
    },
    {
      label: isRefund ? 'Upload Refund Document' : strings.upload_document,
      value: '',
      type: 'upload',
      placeholder: '',
      field: 'attachment',
      validators: [],
      responsive: { xs: 12 },
      required: false,
      multiline: false,
    },
  );
  return form;
};
